import Header from './components/Header';
import Hero from './components/Hero';
import TodayBrief from './components/TodayBrief';
import CategoryStream from './components/CategoryStream';
import Ranking from './components/Ranking';
import ColumnSection from './components/ColumnSection';
import Faq from './components/Faq';
import About from './components/About';
import Subscribe from './components/Subscribe';
import Footer from './components/Footer';
import BackToTop from './components/BackToTop';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TodayBrief />
        <CategoryStream />
        <Ranking />
        <ColumnSection />
        <Faq />
        <About />
        <Subscribe />
      </main>
      <Footer />
      <BackToTop />
    </>
  );
}